import {Box, SubNav} from '@primer/react-brand/esm'
import {usePageMatcher} from '@github-ui/swp-core/lib/hooks/use-page-matcher'
import {clsx} from 'clsx'
import {isLink, isLinkGroup} from '../../types'
import type {FlexSuiteSubNavProps} from './types'
import styles from './FlexSuiteSubNav.module.css'

export function FlexSuiteSubNav({subNav}: FlexSuiteSubNavProps) {
  const {subNavHeading, subNavSubHeading, subNavLinks, subNavCta} = subNav.fields
  const {isCurrentPage} = usePageMatcher()

  return (
    <>
      <SubNav className={styles.aligned}>
        {subNavHeading && <SubNav.Heading href={subNavHeading.fields.href}>{subNavHeading.fields.text}</SubNav.Heading>}

        {subNavSubHeading && (
          <SubNav.SubHeading
            href={subNavSubHeading.fields.href}
            {...(isCurrentPage(subNavSubHeading.fields.href) ? {'aria-current': 'page'} : {})}
          >
            {subNavSubHeading.fields.text}
          </SubNav.SubHeading>
        )}

        {subNavLinks?.map(
          linkOrLinkGroup =>
            (isLink(linkOrLinkGroup) && (
              <SubNav.Link
                key={linkOrLinkGroup.sys.id}
                href={linkOrLinkGroup.fields.href}
                {...(isCurrentPage(linkOrLinkGroup.fields.href) ? {'aria-current': 'page'} : {})}
              >
                {linkOrLinkGroup.fields.text}
              </SubNav.Link>
            )) ||
            (isLinkGroup(linkOrLinkGroup) && (
              <SubNav.Link key={linkOrLinkGroup.sys.id} href="">
                {linkOrLinkGroup.fields.label}

                <SubNav.SubMenu variant="dropdown">
                  {linkOrLinkGroup.fields.links.map(link => (
                    <SubNav.Link
                      key={link.sys.id}
                      href={link.fields.href}
                      {...(isCurrentPage(link.fields.href) ? {'aria-current': 'page'} : {})}
                    >
                      {link.fields.text}
                    </SubNav.Link>
                  ))}
                </SubNav.SubMenu>
              </SubNav.Link>
            )),
        )}

        {subNavCta && <SubNav.Action href={subNavCta.fields.href}>{subNavCta.fields.text}</SubNav.Action>}
      </SubNav>
      <Box
        data-testid="flex-suite-sub-nav-spacer"
        className={clsx(
          styles.FlexSuiteSubNavSpacer,
          subNavSubHeading && !isCurrentPage(subNavSubHeading.fields.href) && styles.twoRows,
        )}
      />
    </>
  )
}
